$(document).ready(function () {
  //BLOQUEAR MENU
  // $('body').on('click', '.menu-zabalera-blokeatu', function () {
  //   $(".barramenu").toggleClass("menu-zabalduta");
  //   $(".body-content").toggleClass("menu-zabalduta");
  //   $(".barratop").toggleClass("menu-zabalduta");
  // });

  //DESPLEGAR CONFIGURACIÓN
  $('body').on('click', '.desplegar-menuconf', function () {
    $(".conf-menu").toggleClass("agertu");
    $(".titulo-menu-configuracion").toggleClass("agertu");
  });

  //PLEGAR - DESPLEGAR PANELES

  /* $(".plegarpanel").click(function () {
       $(this).parent(".nuevo-panel").toggleClass("plegado");
   });

   $(".nuevo-panel").click(function () {
   });*/

  $('body').on('click', '.plegarpanel', function () {
    $(this).parent().parent(".card").toggleClass("plegado");
  });

  //PLEGAR - DESPLEGAR SELECTOR MÁQUINAS
  $('body').on('click', '.desplegar-selector-maquina', function () {
    $(this).parent(".cont-select-maquinas-out").toggleClass("desplegar");
  });
  $('body').on('click', '.no-contraer-click-maquina.desplegar .clickable', function () {
    $(this).parent(".cont-select-maquinas").parent(".cont-select-maquinas-out").toggleClass("desplegar");
  });

  $('body').on('click', '.desplegar .clickable', function () {
    $(this).parent(".cont-select-maquinas").parent(".cont-select-maquinas-out").toggleClass("desplegar");
  });
  

  //ITXURA ALDATU ILUNA/ARGIA

  /*  $(".itxura-aldaketa").click(function () {
        $("body").toggleClass("iluna");
    });*/


  // $('body').on('click', '.itxura-aldaketa-iluna', function () {
  //   $("body").addClass("iluna");
  //   $(".itxura-aldaketa-iluna").addClass("aukeratuta");
  //   $(".itxura-aldaketa-argia").removeClass("aukeratuta");
  // });


  // $('body').on('click', '.itxura-aldaketa-argia', function () {
  //   $("body").removeClass("iluna");
  //   $(".itxura-aldaketa-argia").addClass("aukeratuta");
  //   $(".itxura-aldaketa-iluna").removeClass("aukeratuta");
  // });


  //lighbox

  $('body').on('click', '.lightbox_trigger', function () {

    //prevent default action (hyperlink)
    // e.preventDefault();

    //Get clicked link href
    var image_href = $(this).attr("src");

    /* 	
    If the lightbox window HTML already exists in document, 
    change the img src to to match the href of whatever link was clicked
	
    If the lightbox window HTML doesn't exists, create it and insert it.
    (This will only happen the first time around)
    */

    if ($('#lightbox').length > 0) { // #lightbox exists

      //place href as img src value
      $('#content').html('<img src="' + image_href + '" />');

      //show lightbox window - you could use .show('fast') for a transition
      $('#lightbox').show();
    }

    else { //#lightbox does not exist - create and insert (runs 1st time only)

      //create HTML markup for lightbox window
      var lightbox =
        '<div id="lightbox">' +
        '<p></p>' +
        '<div id="content">' + //insert clicked link's href into img src
        '<img src="' + image_href + '" />' +
        '</div>' +
        '</div>';

      //insert lightbox HTML into page
      $('body').append(lightbox);
    }

  });

  //Click anywhere on the page to get rid of lightbox window
  $('body').on('click', '#lightbox', function () { //must use live, as the lightbox element is inserted into the DOM

    $('#lightbox').hide();
  });


  // Areas productivas (menu)
  $('body').on('click', '.cont-areas-productivas-menu *', function (e) {
    e.stopPropagation();
  });
  $('body').on('click', '.k-animation-container-shown *', function (e) { 
    e.stopPropagation();
  });

  //POSICIONAR ELEMENTO RESPECTO A MOUSE
  /* var tooltipSpan = document.getElementsByClassName('posicion-raton');
  window.onmousemove = function (e) {
    var x = e.clientX,
      y = e.clientY;
    [].forEach.call(tooltipSpan, function (el) {

      el.style.top = (y + 20) + 'px';
      el.style.left = (x + 20) + 'px';

    });
  }; */
  //POSICIONAR TOOLTIP RESPECTO A MOUSE
  var tooltipSpan1 = document.getElementsByClassName('tooltiptext');
  var tooltipSpan4 = document.getElementsByClassName('tooltiptextHome');
  var tooltipSpan2 = document.getElementsByClassName('tooltipTextHeader');
  var tooltipSpan3 = document.getElementsByClassName('posicion-raton');
  window.onmousemove = function (e) {
      for(var i= 0; i< tooltipSpan1.length;i++){
        var element = tooltipSpan1[i]; 
        element.style.position = "absolute";
        element.style.top = (e.offsetY  + 20) + 'px';
        element.style.left =  (e.offsetX - 130) + 'px';
      }
      for(var i= 0; i< tooltipSpan4.length;i++){
        var element = tooltipSpan4[i]; 
        element.style.position = "absolute";
        element.style['z-index'] = "1050";
        element.style['left'] = "0";
        element.style['right'] = "0";
      }
      for(var i= 0; i< tooltipSpan2.length;i++){
        var element = tooltipSpan2[i]; 
        element.style.top = (e.clientY  + 20) + 'px';
        element.style.left =  (e.clientX) + 'px';
      }
      for(var i= 0; i< tooltipSpan3.length;i++){
        var element = tooltipSpan2[i]; 
        element.style.top = e.clientY  +5 + 'px';
        element.style.left =  e.clientX + 5 + 'px';
      }
  };

});